import { render, staticRenderFns } from "./editPayGiftsDetail.vue?vue&type=template&id=1c7c9e04&scoped=true"
import script from "./editPayGiftsDetail.vue?vue&type=script&lang=js"
export * from "./editPayGiftsDetail.vue?vue&type=script&lang=js"
import style0 from "./editPayGiftsDetail.vue?vue&type=style&index=0&id=1c7c9e04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7c9e04",
  null
  
)

export default component.exports